import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "testimonial-area pt-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "position-relative z-1" }
const _hoisted_4 = { class: "testimonial-single-item-two" }
const _hoisted_5 = { class: "d-flex align-items-center mb-32" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "flex-grow-1 ms-4" }
const _hoisted_9 = { class: "ps-0 list-unstyled d-flex align-items-center gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "testimonial-wrap bg-img pb-100",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section-title text-center mw-860 m-auto mb-90" }, [
          _createElementVNode("span", { class: "top-title" }, "آراء العملاء"),
          _createElementVNode("h2", { class: "text-white" }, "رضا العملاء هو أساس خدمتنا"),
          _createElementVNode("p", { class: "text-white" }, " آراء عملائنا تعكس جودة التجربة واستقرار الخدمة التي نقدمها. ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Swiper, {
            slidesPerView: 1,
            spaceBetween: 50,
            centeredSlides: false,
            preventClicks: true,
            loop: true,
            autoplay: {
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },
            navigation: {
              nextEl: '.next',
              prevEl: '.prev',
            },
            breakpoints: {
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              992: {
                slidesPerView: 2,
              },
              1440: {
                slidesPerView: 2,
              },
              1600: {
                slidesPerView: 2,
              },
            },
            modules: _ctx.modules,
            class: "testomonial-slide-two"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial, index) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("img", {
                            src: testimonial.image,
                            alt: testimonial.name
                          }, null, 8, _hoisted_7)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("ul", _hoisted_9, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                              return _createElementVNode("li", { key: star }, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("i", { class: "ti ti-star-filled" }, null, -1)
                              ]))])
                            }), 64))
                          ]),
                          _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1)
                        ])
                      ]),
                      _createElementVNode("p", null, _toDisplayString(testimonial.review), 1)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules"]),
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"testomonial-controller\"><div class=\"controller-icon prev\"><i class=\"ti ti-arrow-left\"></i></div><div class=\"controller-icon next\"><i class=\"ti ti-arrow-right\"></i></div></div>", 1))
        ])
      ], 4)
    ])
  ]))
}